<div class="wrapper">
  <div class="header" [ngClass]="{ 'UAT': environmentCode === 'UAT' }">
    <div class="left">
      <a routerLink="/">
        <img class="logo" src="assets/images/header-logo.svg" alt="Header Logo" tabindex="0" />
      </a>
      <app-header-navigation></app-header-navigation>
    </div>
    <div class="right align-items-center">
      @if (authService.isAuthenticated()) {
      <button class="help-icon p-0">
        <a href="https://kultura.sharepoint.com/sites/15LNA/Koplietojamie%20dokumenti/Forms/AllItems.aspx?id=%2Fsites%2F15LNA%2FKoplietojamie%20dokumenti%2FLatvijas%20Nacion%C4%81lais%20arh%C4%ABvs%2FPakalpojumu%20port%C4%81ls&viewid=1519adf7%2D1b3d%2D4f01%2D99aa%2De62d391c3164&CT=1778245356245&OR=OWA%2DNT%2DMail&CID=c3053b2d%2D7e3c%2D850f%2Dce8b%2D8ed854b3b222"
          target="_blank">
          <img class="help-icon" src="assets/images/help-icon.svg" alt="help icon" />
        </a>
      </button>
      <button class="bell-icon p-0" (click)="handleBellClick()">
        <img src="assets/images/notification-bell.svg" alt="bell icon" />
        @if (unreadNotificationCount > 0) {
        <span class="notification-badge"></span>
        }
      </button>

      <div class="name-icon" (click)="handleNameIconClick()" (keyup.enter)="handleNameIconClick()"
        (keydown.enter)="handleNameIconClick()" (keydown.space)="handleNameIconClick()" tabindex="0">
        <p>{{ getNameLetters() }}</p>
      </div>
      }
      <button class="secondary logout" (click)="handleLogout()">
        {{ 'components.header.logout' | translate }}
        <img src="assets/images/logout-icon.svg" alt="logout" />
      </button>
    </div>
  </div>
</div>

<app-confirm-modal
  [isOpen]="isLogoutConfirmOpen"
  title="logoutUnsavedChangesTitle"
  bodyText="logoutUnsavedChangesBody"
  confirmText="logoutConfirm"
  denyText="logoutDeny"
  (confirm)="confirmLogout()"
  (cancel)="cancelLogout()" />
